import React, { useEffect } from "react"
import { useSelector } from "react-redux"

import PlCapture from "./PlCapture"

const ThermalPrintListener = () => {
  const printRequests =
    useSelector(state => state.printRequests)

  const setPixelRatio = () => {
    const r = document.querySelector(":root")

    r.style.setProperty(
      "--pixel-ratio",
      window.devicePixelRatio
    )
  }

  useEffect(() => {
    setPixelRatio()
  }, [])

  return (
    printRequests.map(printRequest =>
      <PlCapture
        key={printRequest.printRequestId}
        printRequest={printRequest}
      />
    )
  )
}

export default ThermalPrintListener